import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { AppRoutes } from "../components/routes";
import { QueryClient, QueryClientProvider } from "react-query";
import { Slide } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const csrfToken = (document.querySelector("meta[name=csrf-token]") as HTMLMetaElement)
  ?.content;
axios.defaults.headers.common["X-CSRF-Token"] = csrfToken;
axios.defaults.headers.common["Accept"] = "application/json";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

const inferTitle = (path, title) => {
  if (title) {
    return `Lusian - ${title}`;
  } else {
    return "Lusian";
  }
};

const App = () => {
  return (
    <>
      <Router>
        <Routes>
          {AppRoutes.map(([path, Component, title]) => (
            <Route
              key={path as string}
              path={path as string}
              Component={(props) => (
                <>
                  <Helmet>
                    <title>{inferTitle(path, title)}</title>
                  </Helmet>
                  <Component {...props} />
                </>
              )}
            />
          ))}
          <Route
            path="*"
            Component={() => {
              return <div>Not found</div>;
            }}
          />
        </Routes>
      </Router>

      <ToastContainer
        position="bottom-left"
        hideProgressBar
        autoClose={1750}
        transition={Slide}
      />
    </>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
